module.exports = __webpack_public_path__ + "static/media/users_2.af78e5d8.svg";